var map = {
	"./bg-convite.webp": 1146,
	"./bg-deck-cards.webp": 1147,
	"./bg-dog-collar-preta.webp": 1148,
	"./bg-dog-collar.webp": 1149,
	"./bg-mesa-ampliado.webp": 1150,
	"./bg-mesa.webp": 1151,
	"./bg-parede.webp": 1152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1145;